import React from 'react'
import { get } from 'lodash'
import { Button, Table, Label } from 'semantic-ui-react'

import utils from '../../../utils'
import LocationCell from './LocationCell'
import FindDriver from '../../orders/components/OrderListItem/ActionButtons/FindDriver'
import DriverPendingTimer from '../../../components/orders/DriverPendingTimer'

export default class DriverCell extends React.PureComponent {
  state = { finding: false }

  renderAssignedDriver = () => {
    const { delivererTel, delivererName } = this.props

    const callableDriverTel = utils.helpers.convertToLocalPhoneNumber(delivererTel)

    return (
      <div key="assign-driver">
        <div>
          <strong>{delivererName}</strong>
        </div>
        <div>
          <a href={utils.helpers.convertToCallableLink(callableDriverTel)}>
            <Label style={{ marginTop: 5, width: 120 }}>{delivererTel}</Label>
          </a>
        </div>
      </div>
    )
  }

  renderLiveTracking = () => {
    const { showLiveTracking, readOnly } = this.props

    return (
      <div key="live-tracking">
        <Button
          size="mini"
          color="black"
          style={{ width: 120, margin: '5px 0px 0px 0px' }}
          onClick={showLiveTracking}
          disabled={readOnly}
        >
          Live Tracking
        </Button>
      </div>
    )
  }

  renderDriverPending = () => {
    const { delivererTel, delivererName, order } = this.props
    const pendingExpiredAt = get(order,'pending_driver_expired_at')

    return (
      <DriverPendingTimer key="pending-timer" driverName={delivererName} driverTel={delivererTel} expiredAt={pendingExpiredAt} />
    )
  }

  renderFindDriver = () => {
    const { finding } = this.state
    const { showManualAssign, order, isQueueOrder, queueOrders } = this.props
    const delivererName = get(order, 'deliverer_name', false)

    return (
      <FindDriver
        key="find-driver"
        isExpress
        order={order}
        finding={finding}
        refindDriver={delivererName}
        isQueueOrder={isQueueOrder}
        queueOrders={queueOrders}
        setLoading={(field, val) => this.setState({ finding: val })}
        showManualAssign={showManualAssign}
      />
    )
  }

  renderLocationCell = () => {
    const { receivers, order } = this.props

    const pickUp = get(order, 'pickup_location')
    const distance = get(order, 'delivery_distance')

    return <LocationCell key="location" distance={distance} pickUp={pickUp} receivers={receivers} />
  }

  render() {
    const { order, rowSpan, style = {} } = this.props

    const actions = []
    const hasDriver = order.deliverer_name && order.deliverer
    const hasPendingDriver = get(order, 'pending_driver_expired_at') && order.pending_driver

    const isPendingOrder = order.status === 'pending'
    const isInProgress = ['confirmed', 'outForDelivery'].includes(order.status)

    const isSameDayOrder = get(order, 'courier_type') === 'same_day_delivery'

    if (hasPendingDriver)
      actions.push(this.renderDriverPending())
    else if (isSameDayOrder && isPendingOrder)
      actions.push(this.renderFindDriver())
    else {
      actions.push(this.renderAssignedDriver())
      actions.push(this.renderLocationCell())

      if (isInProgress && hasDriver) actions.push(this.renderLiveTracking())
    }

    return (
      <Table.Cell textAlign="center" rowSpan={rowSpan} style={style}>
        {actions}
      </Table.Cell>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/express/components/DriverCell.js